import React from "react";
import { RiExternalLinkLine } from "react-icons/ri";
import { FiGithub } from "react-icons/fi";
const Project = ({ project }) => {
  const { name, technology, projectImg, gitLink, url } = project;
  return (
    <div >
      <div className="card bg-neutral rounded-sm cursor-pointer shadow-xl">
        <img className="rounded-sm" src={projectImg} alt="Project jpg" />
        <div className="card-body">
          <h2 className="card-title text-secondary capitalize">{name}</h2>
          <p>If a dog chews shoes whose shoes does he choose?</p>
          <div className="">
            {technology.map((tech,idx) => (
              <p key={idx} className="font-mono text-accent inline mr-3 text-sm">
                {tech}
              </p>
            ))}
          </div>
          <div className="flex justify-end items-center">
            <a
              href={gitLink}
              aria-label="GitHub"
              target="_blank"
              rel="noreferrer"
            >
              <FiGithub className="text-accent hover:text-primary text-xl mr-2" />
            </a>
            <a
              href={url}
              aria-label="External Link"
              target="_blank"
              rel="noreferrer"
            >
              <RiExternalLinkLine className="text-accent hover:text-primary text-2xl mr-2" />
            </a>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
